import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import GLNDetailView from "./GLNDetailView";
import GLNFilterView from "./GLNFilterView";

const GLNView = () => {
  const [inputData, setInputData] = useState(new Map());
  const [headerCheckboxState, setHeaderCheckboxState] = useState(false);
  const [facilityHeaderCheckboxState, setFacilityHeaderCheckboxState] =
    useState(false);
  const [shouldScroll, setShouldScroll] = useState(false);
  const detailViewRef = useRef(null);

  // Function to handle URL parameters and trigger search
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const glnIdFromUrl = queryParams.get("glnid");

    if (glnIdFromUrl) {
      // Create a Map with the GLN ID to pass to the filter component
      const urlData = new Map();
      urlData.set("glnId", glnIdFromUrl);

      // Wait a moment to allow components to render before triggering submit
      setTimeout(() => {
        handleSubmit(urlData, true); // Pass true to indicate auto-scroll
      }, 500);
    }
  }, []);

  // Effect to scroll to detail view when data is loaded and scrolling is requested
  useEffect(() => {
    if (shouldScroll && inputData.size > 0 && detailViewRef.current) {
      // Allow time for the detail view to render with data
      setTimeout(() => {
        detailViewRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        setShouldScroll(false); // Reset scroll flag after scrolling
      }, 1000); // Adjust timeout if needed to ensure data is loaded
    }
  }, [inputData, shouldScroll]);

  const handleSubmit = (newData, scroll = true) => {
    setInputData((prevData) => {
      const updatedData = new Map(prevData);
      newData.forEach((value, key) => {
        updatedData.set(key, value);
      });
      return updatedData;
    });

    // Set scrolling flag when data is submitted
    if (scroll) {
      setShouldScroll(true);
    }
  };

  return (
    <Grid sx={{ marginTop: "6em", marginBottom: "3em", padding: "1em" }}>
      <GLNFilterView
        handleSubmit={handleSubmit}
        headerCheckboxState={headerCheckboxState}
        setHeaderCheckboxState={setHeaderCheckboxState}
        facilityHeaderCheckboxState={facilityHeaderCheckboxState}
        setFacilityHeaderCheckboxState={setFacilityHeaderCheckboxState}
      />
      <div ref={detailViewRef}>
        <GLNDetailView
          inputData={inputData}
          headerCheckboxState={headerCheckboxState}
        />
      </div>
    </Grid>
  );
};

export default GLNView;
